import { withUiBlock } from './src/index';


export { withUiBlock };
